import * as Sentry from '@sentry/react';

import config from './config';

if (window.location.host.startsWith('localhost') === false) {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    release: process.env.REACT_APP_VERSION,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Noise from Outlook SafeLinks / Microsoft link scanners (CefSharp), not from the app code.
    ignoreErrors: [/Object Not Found Matching Id/],
  });
}
